import { Box, styled } from "@material-ui/core";
import { Title2 } from "components/design-system/atoms/Typography";
import Body from "components/design-system/atoms/Typography/Body";

const TurquoiseTitle2 = styled(Title2)(({ theme }) => ({
  color: theme.palette.turquoise.main,
  fontSize: 21,
  marginBottom: "10px",
}));

const BodyWithLineHeight = styled(Body)({
  lineHeight: "140%",
  fontSize: "16px",
  color: "secondary",
});

const Li = styled("li")({
  marginBottom: "8px",
});

const BoldText = styled("span")({
  fontWeight: 600,
});

const DrawerWrapper = styled(Box)(({ theme }) => ({
  margin: "24px 8px 24px 8px",
  [theme.breakpoints.down("md")]: {
    margin: "16px 8px 16px 8px",
  },
}));

const BorderBottomBox = styled(Box)({
  borderBottom: "1px solid rgba(219, 223, 232, 0.6)",
});

export default function DurableNewDrawerContent() {
  return (
    <DrawerWrapper>
      <BorderBottomBox pb={5}>
        <Box>
          <BodyWithLineHeight>
            <TurquoiseTitle2>Qu&apos;est ce que le neuf durable ?</TurquoiseTitle2>
            <BoldText>
              Des appareils neufs sélectionnés par nos réparateurs pour leur robustesse et leur durabilité.
            </BoldText>
            <Box>&nbsp;</Box>
            Qui mieux que des professionnels de la réparation pour vous conseiller en électroménager ? Ces appareils
            neufs complètent notre gamme d&apos;appareils reconditionnés pour vous offrir le choix de l&apos;équipement
            durable.
            <Box>&nbsp;</Box>
            <BoldText>Le neuf durable, ce sont des appareils :</BoldText>
            <ul style={{ marginBottom: "0" }}>
              <Li>Sélectionnés par nos réparateurs experts</Li>
              <Li>Conçus pour durer dans le temps</Li>
              <Li>Facilité de réparation garantie</Li>
            </ul>
          </BodyWithLineHeight>
        </Box>
      </BorderBottomBox>
      <Box mt={5}>
        <TurquoiseTitle2> Nos critères de sélection</TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight>
            Si Murfy s&apos;engage sur la réparabilité de ses appareils neufs durables, c&apos;est grâce à des critères
            précis co-construits avec l&apos;Ademe et le Club de la Durabilité&nbsp;:
            <ul style={{ marginBottom: "0" }}>
              <Li>Indice de réparabilité supérieur à 8</Li>
              <Li>Avec des pièces détachées disponibles 15 ans</Li>
              <Li>Conception robuste pour une longue durée de vie</Li>
            </ul>
          </BodyWithLineHeight>
        </Box>
      </Box>
      <Box mt={5}>
        <TurquoiseTitle2>
          Choisir l&apos;électroménager Murfy, c&apos;est s&apos;équiper pour que ça dure.
        </TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight>
            Parce qu&apos;en tant que réparateurs, faire durer les appareils, c&apos;est notre métier. C&apos;est
            pourquoi&nbsp;
            <BoldText>
              nos appareils neufs sont sélectionnés par des professionnels pour leur qualité, leur durabilité et leur
              réparabilité&nbsp;
            </BoldText>
            <Box>&nbsp;</Box>
          </BodyWithLineHeight>
        </Box>
      </Box>
    </DrawerWrapper>
  );
}
